import common from "../common";
import Scene from "./Scene";
import Button from "../ui/Button";

export default class EndScene extends Scene 
{
    constructor()
    {
        super('end');

        this.endPanelShown = false;
    }

    init()
    {
        super.init();

        if(!common.basicMode)
        {
            MEDIATOR.pcApp.enableBall();

            this.showKickPanel();

            common.soundManager.play('sfx_crowd_ambient_loop_00');
        }
        else
        {
            this.showEndPanel();
        }
    }

    showKickPanel()
    {
        var panel = $('<div class="p3-panelKick"></div>');
        this.holder.append(panel);

        var title = $('<div class="p3-panelItem p3-boldText">' + common.config.strings.end_thank_you[common.country] + '</div>');
        panel.append(title);
        var text = $('<div class="p3-panelItem">' + common.config.strings.end_click_the_ball[common.country] + '</div>');
        panel.append(text);

        var kickButton = new Button({bottom:'0%', left:'20%'}, {position:'absolute', width:'60%', height:'70%'});
        this.holder.append(kickButton.htmlElement);
        
        kickButton.initButton('Submit');
        this.signalListeners.push(kickButton.signals.up.add(() => {
            this.kickBall();
            this.animatePanelOut(() => {
                panel.remove();
            });
            kickButton.htmlElement.remove();
        }));
        this.buttons['kick'] = kickButton;

        this.animatePanelIn();
    }

    postInit()
    {
        super.postInit();
    }

    kickBall()
    {
        MEDIATOR.pcApp.kickBall();

        common.soundManager.play('sfx_ball_kick');
        common.soundManager.play(['sfx_crowd_roar_layer_01', 'sfx_crowd_roar_layer_02', 'sfx_crowd_roar_layer_03']);

        setTimeout(() => 
        {
            this.showEndPanel();
        }, 7000);
    }

    showEndPanel()
    {
        if(this.endPanelShown)
        {
            return;
        }
        this.endPanelShown = true;

        var seatNumber = common.seatNumber; //Math.round(Math.random() * 10000);

        var time = 1500;
        if(common.basicMode)
            time = 1;

        setTimeout(() => 
        {
            this.addPanel();

            var title = $('<div class="p3-panelItem p3-boldText">' + common.config.strings.end_seat_number[common.country] + ' ' + seatNumber + '</div>');
            this.panelInner.append(title);
            var text = $('<div class="p3-panelItem" style="font-size:3vh">' + common.config.strings.end_thanks_for_taking_part[common.country] + '</div>');
            this.panelInner.append(text);
    
            var twitterText = common.config.strings.end_twitter_link[common.country].replace("@DHLManUtd", '<a href="https://twitter.com/DHLManUtd" target="_blank">@DHLManUtd</a>');
    
            text = $('<div class="p3-panelItem" style="font-size:3vh">' + twitterText + '</div>');
            this.panelInner.append(text);
    
            var logo = $('<div class="p3-panelItem"><img src="' + common.baseUrl + '/assets/images/ui_logo_1goal_0emissions.png" style="height:10vh" /></div>');
            this.panelInner.append(logo);
    
            this.animatePanelIn();

        }, time);

        if(!common.basicMode)
        {
            common.soundManager.play(['sfx_crowd_roar_layer_01', 'sfx_crowd_roar_layer_02', 'sfx_crowd_roar_layer_03']);
        }
    }
}